export default __webpack_public_path__ + "static/media/room3-BASE.7a5e6e1e.png";